import { Space } from 'antd';
import styled from 'utils/styled';

export const Container = styled.div``;

export const StyledSpace = styled(Space)`
  width: 100%;
`;
